var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cashoutMethod)?_c('div',[_c('cashout-method-details',{attrs:{"data-cashout-method":_vm.cashoutMethod},on:{"update:dataCashoutMethod":[function($event){_vm.cashoutMethod=$event},_vm.updatecashoutMethod],"update:data-cashout-method":function($event){_vm.cashoutMethod=$event}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }